export default __webpack_public_path__ + "static/media/profile.db4f56ea.jpeg";